"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideNavigationPanel = void 0;
var React = require("react");
var LayoutStyles_1 = require("../../styles/LayoutStyles");
var NavHeader = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: LayoutStyles_1.predictiveModelEditorNavItem }, children);
};
var NavMenu = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "".concat(LayoutStyles_1.predictiveModelEditorNavItem, " ").concat(LayoutStyles_1.predictiveModelEditorNavBorder) }, children);
};
var NavBody = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "".concat(LayoutStyles_1.predictiveModelEditorNavItem, " ").concat(LayoutStyles_1.predictiveModelEditorNavBorder) }, children);
};
var NavFooter = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "".concat(LayoutStyles_1.predictiveModelEditorNavItem, " ").concat(LayoutStyles_1.predictiveModelEditorNavBorder) }, children);
};
var SideNavigationPanel = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: LayoutStyles_1.predictiveModelEditorNav }, children);
};
exports.SideNavigationPanel = SideNavigationPanel;
exports.SideNavigationPanel.Header = NavHeader;
exports.SideNavigationPanel.Menu = NavMenu;
exports.SideNavigationPanel.Body = NavBody;
exports.SideNavigationPanel.Footer = NavFooter;
//# sourceMappingURL=SideNavigationPanel.js.map